import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBorrowingBase = function SvgBorrowingBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.539 2.014H32.6v11.77H25.54V2.014Zm2.354 2.354v7.062h2.354V4.368h-2.354Z",
    fill: "#0C1633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.138 13c0-.867.703-1.57 1.57-1.57H31.03c.867 0 1.57.703 1.57 1.57v14.907a1.57 1.57 0 0 1-1.57 1.57H6.708a1.57 1.57 0 0 1-1.57-1.57V13Zm2.354.784v13.339h22.755v-13.34H7.492Z",
    fill: "#0C1633"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.262 17.707c0-.867.702-1.57 1.569-1.57h6.277c.867 0 1.57.703 1.57 1.57v3.923a1.57 1.57 0 0 1-1.57 1.57h-6.277a1.57 1.57 0 0 1-1.57-1.57v-3.923Zm2.354.785v2.354h4.707v-2.354h-4.707ZM9.846 17.707c0-.867.703-1.57 1.57-1.57h3.923c.866 0 1.569.703 1.569 1.57v10.2a1.57 1.57 0 0 1-1.57 1.57h-3.922a1.57 1.57 0 0 1-1.57-1.57v-10.2Zm2.354.785v8.63h2.354v-8.63H12.2Z",
    fill: "#0C1633"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.177 27.123h32.17a1.177 1.177 0 1 1 0 2.353H3.177a1.177 1.177 0 1 1 0-2.353Z",
    fill: "#0C1633"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.485 1.247a.392.392 0 0 0-.447 0L3.662 11.892a.392.392 0 0 0 .223.715h30.753a.392.392 0 0 0 .224-.715L19.485 1.247Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.369.279a1.57 1.57 0 0 1 1.786 0l15.377 10.645a1.57 1.57 0 0 1-.894 2.86H3.885a1.57 1.57 0 0 1-.893-2.86l.67.968-.67-.968L18.369.28ZM6.397 11.43h25.73L19.262 2.524 6.397 11.43ZM65.555 4.368v7.062h2.354V4.368h-2.354ZM63.2 3.976c0-1.083.878-1.962 1.961-1.962h3.139c1.083 0 1.962.879 1.962 1.962v7.846a1.962 1.962 0 0 1-1.962 1.962h-3.139a1.962 1.962 0 0 1-1.961-1.962V3.976Z",
    fill: "#0C1633"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.547 13.784a.392.392 0 0 0-.392.392V26.73c0 .217.175.393.392.393h21.97a.392.392 0 0 0 .392-.393V14.176a.392.392 0 0 0-.393-.392h-21.97Zm-2.746.392a2.746 2.746 0 0 1 2.746-2.746h21.97a2.746 2.746 0 0 1 2.746 2.746V26.73a2.746 2.746 0 0 1-2.747 2.747h-21.97a2.746 2.746 0 0 1-2.745-2.747V14.176Z",
    fill: "#0C1633"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.67 18.492a.392.392 0 0 0-.392.392v1.57c0 .216.175.392.392.392h3.923a.392.392 0 0 0 .392-.393v-1.569a.392.392 0 0 0-.392-.392H59.67Zm-2.746.392a2.746 2.746 0 0 1 2.746-2.746h3.923a2.746 2.746 0 0 1 2.746 2.746v1.57a2.746 2.746 0 0 1-2.746 2.745H59.67a2.746 2.746 0 0 1-2.746-2.746v-1.569ZM50.255 18.492a.392.392 0 0 0-.393.392v7.846c0 .217.176.393.393.393h1.569a.392.392 0 0 0 .392-.393v-7.846a.392.392 0 0 0-.392-.392h-1.57Zm-2.747.392a2.746 2.746 0 0 1 2.747-2.746h1.569a2.746 2.746 0 0 1 2.746 2.746v7.846a2.746 2.746 0 0 1-2.746 2.746h-1.57a2.746 2.746 0 0 1-2.746-2.746v-7.846Z",
    fill: "#0C1633"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.009 27.123h-32.17a1.177 1.177 0 1 0 0 2.353h32.17a1.177 1.177 0 1 0 0-2.353Z",
    fill: "#0C1633"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.147 1.247a.392.392 0 0 0-.447 0L41.325 11.892a.392.392 0 0 0 .223.715h30.754a.392.392 0 0 0 .223-.715L57.147 1.247Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.03.279a1.57 1.57 0 0 1 1.787 0l15.377 10.645a1.57 1.57 0 0 1-.894 2.86H41.547a1.57 1.57 0 0 1-.893-2.86l.67.968-.67-.968L56.03.28ZM44.06 11.43h25.73L56.924 2.524 44.059 11.43ZM65.555 38.892v7.062h2.354v-7.062h-2.354ZM63.2 38.5c0-1.084.878-1.962 1.961-1.962h3.139c1.083 0 1.962.878 1.962 1.962v7.846a1.962 1.962 0 0 1-1.962 1.962h-3.139a1.962 1.962 0 0 1-1.961-1.962V38.5Z",
    fill: "#0C1633"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.547 48.307a.392.392 0 0 0-.392.393v12.554c0 .217.175.392.392.392h21.97a.392.392 0 0 0 .392-.392V48.7a.392.392 0 0 0-.393-.393h-21.97ZM42.8 48.7a2.746 2.746 0 0 1 2.746-2.746h21.97a2.746 2.746 0 0 1 2.746 2.746v12.554A2.746 2.746 0 0 1 67.516 64h-21.97a2.746 2.746 0 0 1-2.745-2.746V48.7Z",
    fill: "#0C1633"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.67 53.015a.392.392 0 0 0-.392.392v1.57c0 .217.175.392.392.392h3.923a.392.392 0 0 0 .392-.392v-1.57a.392.392 0 0 0-.392-.392H59.67Zm-2.746.392a2.746 2.746 0 0 1 2.746-2.746h3.923a2.746 2.746 0 0 1 2.746 2.746v1.57a2.746 2.746 0 0 1-2.746 2.746H59.67a2.746 2.746 0 0 1-2.746-2.746v-1.57ZM50.255 53.015a.392.392 0 0 0-.393.392v7.847c0 .217.176.392.393.392h1.569a.392.392 0 0 0 .392-.392v-7.846a.392.392 0 0 0-.392-.393h-1.57Zm-2.747.392a2.746 2.746 0 0 1 2.747-2.746h1.569a2.746 2.746 0 0 1 2.746 2.746v7.847A2.746 2.746 0 0 1 51.824 64h-1.57a2.746 2.746 0 0 1-2.746-2.746v-7.846Z",
    fill: "#0C1633"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.009 61.646h-32.17a1.177 1.177 0 0 0 0 2.354h32.17a1.177 1.177 0 1 0 0-2.354Z",
    fill: "#0C1633"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.147 35.77a.392.392 0 0 0-.447 0L41.325 46.416a.392.392 0 0 0 .223.715h30.754a.392.392 0 0 0 .223-.715L57.147 35.77Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.03 34.803a1.57 1.57 0 0 1 1.787 0l15.377 10.645a1.57 1.57 0 0 1-.894 2.86H41.547a1.57 1.57 0 0 1-.893-2.86l.67.968-.67-.968L56.03 34.803ZM44.06 45.953h25.73l-12.865-8.906-12.865 8.907ZM27.893 38.892v7.062h2.354v-7.062h-2.354Zm-2.354-.392c0-1.084.878-1.962 1.961-1.962h3.139c1.083 0 1.961.878 1.961 1.962v7.846a1.962 1.962 0 0 1-1.961 1.962H27.5a1.962 1.962 0 0 1-1.961-1.962V38.5Z",
    fill: "#0C1633"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.885 48.307a.392.392 0 0 0-.393.393v12.554c0 .217.176.392.393.392h21.97a.392.392 0 0 0 .392-.392V48.7a.392.392 0 0 0-.393-.393H7.884Zm-2.747.393a2.746 2.746 0 0 1 2.747-2.746h21.97A2.746 2.746 0 0 1 32.6 48.7v12.554A2.746 2.746 0 0 1 29.854 64H7.884a2.746 2.746 0 0 1-2.746-2.746V48.7Z",
    fill: "#0C1633"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.008 53.015a.392.392 0 0 0-.392.392v1.57c0 .217.175.392.392.392h3.923a.392.392 0 0 0 .392-.392v-1.57a.392.392 0 0 0-.392-.392h-3.923Zm-2.746.392a2.746 2.746 0 0 1 2.746-2.746h3.923a2.746 2.746 0 0 1 2.746 2.746v1.57a2.746 2.746 0 0 1-2.746 2.746h-3.923a2.746 2.746 0 0 1-2.746-2.746v-1.57ZM12.592 53.015a.392.392 0 0 0-.392.392v7.847c0 .217.176.392.392.392h1.57a.392.392 0 0 0 .392-.392v-7.846a.392.392 0 0 0-.392-.393h-1.57Zm-2.746.392a2.746 2.746 0 0 1 2.746-2.746h1.57a2.746 2.746 0 0 1 2.746 2.746v7.847A2.746 2.746 0 0 1 14.162 64h-1.57a2.746 2.746 0 0 1-2.746-2.746v-7.846Z",
    fill: "#0C1633"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.347 61.646H3.177a1.177 1.177 0 0 0 0 2.354h32.17a1.177 1.177 0 1 0 0-2.354Z",
    fill: "#0C1633"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.485 35.77a.392.392 0 0 0-.447 0L3.662 46.416a.392.392 0 0 0 .223.715h30.753a.392.392 0 0 0 .224-.715L19.485 35.77Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.369 34.803a1.57 1.57 0 0 1 1.786 0l15.377 10.645a1.57 1.57 0 0 1-.894 2.86H3.885a1.57 1.57 0 0 1-.893-2.86l.67.968-.67-.968 15.377-10.645ZM6.397 45.953h25.73l-12.865-8.906-12.865 8.907Z",
    fill: "#0C1633"
  })));
};

var Memo = /*#__PURE__*/memo(SvgBorrowingBase);

export { Memo as default };
//# sourceMappingURL=borrowing-base.svg.js.map
